module.exports = __webpack_public_path__ + "static/apple_store_badge-fb1723b41e8ba0c5ce6bd4ea587a30eb.svg";